import React, { useState, useEffect } from "react";
import {
  Button,
  Box,
  Image,
  Checkbox,
  CardBody,
  CardHeader,
  Text,
  Input,
  useTheme,
  Flex,
  Card,
  Spinner,
  InputRightElement,
  InputGroup,
  Icon,
} from "@chakra-ui/react";
import { IoEyeOutline, IoEyeOffSharp } from "react-icons/io5";
import logo from "../../assests/icons/insplogo.png";
import { useNavigate } from "react-router-dom";
import { mentorLogin } from "../../store/slice/authenticationSlice";
import { useDispatch, useSelector } from "react-redux";

import { useToastContext } from "../../components/toastNotificationProvider/ToastNotificationProvider";
const LoginScreen = () => {
  const { primaryBlue, primaryBlueLight } = useTheme().colors.pallete;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const { addNotification } = useToastContext();
  const dispatch = useDispatch();
  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const handleLogin = () => {
    if (!email || !password) {
      addNotification("Please enter email and password", "error", 3000);
      return;
    }
    setIsLoading(true);
    dispatch(mentorLogin({ email, password }))
      .unwrap()
      .then((response) => {
        console.log("Login successfully:", response);
        addNotification("Login successfully", "success", 3000);
        navigate("/assignment");
      })
      .catch((error) => {
        console.error("Error while login:", error);
        addNotification(
          "You have entered the wrong email or password.Please try again !!",
          "error",
          4000
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      h="100vh"
      bgGradient="linear(180deg, #FCFCFC 0%, #E8F2F9 100%)"
    >
      <Card width="32%">
        <CardHeader>
          <Flex justifyContent="center">
            <Image src={logo} alt="Logo" />
          </Flex>
        </CardHeader>

        <CardBody>
          <Box mb={4}>
            <Text
              color={"#3A3541DE"}
              fontSize={"24px"}
              fontWeight={400}
              letterSpacing={"0.18px"}
              lineHeight={"32px"}
            >
              Welcome to INSP! 👋🏻
            </Text>
            <Text
              fontSize={"12px"}
              lineHeight={"20px"}
              letterSpacing={"0.15px"}
              color={"#3A3541AD"}
              mb={6}
            >
              Please sign-in to your account
            </Text>
            <Input
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Box>

          <Box mb={4}>
            <InputGroup>
              <Input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <InputRightElement>
                <Icon
                  as={showPassword ? IoEyeOffSharp : IoEyeOutline}
                  color="gray"
                  cursor="pointer"
                  boxSize={5}
                  onClick={handleTogglePasswordVisibility}
                />
              </InputRightElement>
            </InputGroup>
          </Box>

          <Button
            backgroundColor="#3C8DBC"
            width="100%"
            fontSize={"15px"}
            letterSpacing={"0.46px"}
            fontWeight={500}
            bg={primaryBlue}
            color="white"
            _hover={{ bg: primaryBlueLight }}
            onClick={handleLogin}
            disabled={isLoading}
          >
            {isLoading ? <Spinner size="md" color="white" /> : "Login"}
          </Button>
        </CardBody>
      </Card>
    </Flex>
  );
};

export default LoginScreen;
